export default __webpack_public_path__ + "static/media/backgroundLogoAprobank.0ed00a63.svg";